import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ComponentsModule, FacadeView, SvgWorkspaceComponent } from 'cloud-shared-lib';
import { interval, Observable, tap } from 'rxjs';

@Component({
  selector: 'cutting-panel-schema',
  templateUrl: './panel-schema.component.html',
  standalone: true,
  imports: [ComponentsModule, NgIf, AsyncPipe],
})
export class PanelSchemaComponent implements OnInit {
  @Input() panel: FacadeView;

  @ViewChild('svgWorkspace') svgWorkspace: SvgWorkspaceComponent;

  render$: Observable<number>;

  ngOnInit(): void {
    /* TODO: Т к раньше это делалось в ngAfterViewChecked, это очень перегружало основной поток и вызывало циклические рендеры,
     * чтобы ничего не поломать и снизить нагрузку добавлен этот костыль,
     * но перерисовку все равно необходимо переделать, чтобы схема перерисовывалась только при реальных изменениях в панели
     */
    this.render$ = interval(300).pipe(
      tap(() => {
        this.redraw();
      })
    );
  }

  redraw(): void {
    this.svgWorkspace?.draw(this.panel);
  }
}
